export default "__VITE_ASSET__6g7c3gT6__"